import { IDashboardRepository } from '../../domain/repositories/IDashboardRepository';
import { DashboardStatsDTO } from '../dto/DashboardStatsDTO';
import { DashboardMapper } from '../mappers/DashboardMapper';

/**
 * Get Dashboard Stats Use Case
 * Retrieves dashboard statistics for a specific user role
 */
export class GetDashboardStatsUseCase {
  constructor(private dashboardRepository: IDashboardRepository) {}

  async execute(role: string): Promise<DashboardStatsDTO> {
    const stats = await this.dashboardRepository.getDashboardStats(role);
    return DashboardMapper.statsToDTO(stats);
  }
}
